import { Controller } from "@hotwired/stimulus";
import update from "../services/bookingService";

export default class extends Controller {
  static targets = ["form"];

  static values = {
    id: { type: Number },
    method: { type: String, default: "PATCH" },
    loadingText: { type: String, default: "Saving..." },
  };

  save() {
    const submitButton = this.formTarget.querySelector('input[type="submit"]');
    const originalButtonText = submitButton.value;

    submitButton.disabled = true;
    submitButton.value = this.loadingTextValue;

    const success = () => {
      submitButton.disabled = false;
      submitButton.value = originalButtonText;
    };

    const error = () => {
      submitButton.disabled = false;
      submitButton.value = originalButtonText;
    };

    const formData = new FormData(this.formTarget);

    const data = {
      booking: {
        note: formData.get("note"),
      },
    };

    update({
      id: this.idValue,
      data,
      success,
      error,
    });
  }
}
